export default "__VITE_ASSET__74f638e1__"